// Mirrors webapp/src/constants.ts (subset used by the cloned surface).

export enum Permission {
    ManageBoardType = 'manage_board_type',
    DeleteBoard = 'delete_board',
    ShareBoard = 'share_board',
    ManageBoardRoles = 'manage_board_roles',
    ChannelCreatePost = 'create_post',
    ManageBoardCards = 'manage_board_cards',
    ManageBoardProperties = 'manage_board_properties',
    CommentBoardCards = 'comment_board_cards',
    ViewBoard = 'view_board',
    DeleteOthersComments = 'delete_others_comments',
}

class Constants {
    static readonly menuColors: Record<string, string> = {
        propColorDefault: '默认',
        propColorGray: '灰色',
        propColorBrown: '棕色',
        propColorOrange: '橙色',
        propColorYellow: '黄色',
        propColorGreen: '绿色',
        propColorBlue: '蓝色',
        propColorPurple: '紫色',
        propColorPink: '粉色',
        propColorRed: '红色',
    }

    static readonly minColumnWidth = 100
    static readonly defaultTitleColumnWidth = 280
    static readonly tableHeaderId = '__header'
    static readonly tableCalculationId = '__calculation'
    static readonly titleColumnId = '__title'
    static readonly badgesColumnId = '__badges'

    static readonly versionString = '8.0.0'
    static readonly versionDisplayString = '2024 年 6 月'

    static readonly globalTeamId = '0'
    static readonly noChannelID = '0'

    static readonly defaultLocale = 'zh-CN'

    /** bootstrap() signs in with this account so the app opens straight into a board */
    static readonly demoAccount = {
        username: '张伟',
        password: '演示',
    }

    // webapp/src/store/sidebar.ts: DefaultCategory
    static readonly defaultCategoryName = '看板'

    static readonly localStorageKeys = {
        theme: 'Focalboard-theme',
        lastTeamId: 'Focalboard-last-team-id',
        sidebarSize: 'Focalboard-sidebar-size',
        collapsedCategories: 'Focalboard-collapsed-categories',
        mockDatabase: 'Focalboard-mock-db-v3',
        authToken: 'Focalboard-token',
        myUserId: 'Focalboard-user-id',
    }
}

export {Constants}
